import React from 'react';
import { LogIn } from 'lucide-react';
import { buildGoogleSignInUrl } from '../utils/authUrls';

interface SignInWithGoogleButtonProps {
  returnTo?: string;
  className?: string;
}

const SignInWithGoogleButton: React.FC<SignInWithGoogleButtonProps> = ({
  returnTo,
  className = '',
}) => {
  return (
    <button
      type="button"
      data-testid="sign-in-with-google"
      onClick={() => {
        window.location.href = buildGoogleSignInUrl(returnTo || window.location.pathname + window.location.search);
      }}
      className={`inline-flex items-center justify-center space-x-2 bg-white text-secondary-900 px-6 py-3 rounded-md hover:bg-secondary-100 transition-colors font-medium ${className}`.trim()}
    >
      <LogIn className="h-4 w-4" />
      <span>Sign in with Google</span>
    </button>
  );
};

export default SignInWithGoogleButton;
